/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type FormWorkflowStatus = typeof FormWorkflowStatus[keyof typeof FormWorkflowStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormWorkflowStatus = {
  AwaitingClinician: 'AwaitingClinician',
  AwaitingPatient: 'AwaitingPatient',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;
